import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { ClientSideStorageService } from 'src/app/services/client-side-storage.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { environment } from 'src/environments/environment';

// import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { defaultConfig } from 'src/config/default-config';
import { coteivoryConfig } from 'src/config/Cote-ivory-config';
import { zimConfig } from 'src/config/zim-config';
import { botswanaConfig } from 'src/config/botswana-config';

interface TableRow {
  dealId: number;
  dealTitle: string;
  validTo: string;
  status: string;
  currentHighProspects: number;
  messagesSent: number;
  currentPendingProspects: number;
  totalSpent: number;
  originalData: any;  // This will hold the entire original object
}

@Component({
  selector: 'app-paymenthistory',
  templateUrl: './paymenthistory.component.html',
  styleUrl: './paymenthistory.component.scss'
})


export class PaymenthistoryComponent implements OnInit {



  placeholders = environment.placeholders as { [key: string]: string };
  placeHolders: any;
  reportPlaceHolders: any;
  paymentPlaceHolder: any;
  dashboardPlaceHolder: any;
  toolTips: any;

  userData: any;
  paymentTotalData: any;
  paymentTotalDataReport: any;


  activePage: number = 1;
  displayedColumns: string[] = ['date', 'email', 'name', 'amount', 'status', 'description', 'type', 'display_brand', 'card', 'action'];
  dataSource = new MatTableDataSource<TableRow>();
  totalCount: number = 0;
  currentPage: any;
  pageSize: number = 10;
  today: string = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  transactions: any[] = [];
  selectedTxn: any;
  receiptlogo: any;

  @ViewChild('receiptModal') receiptModal: any;

  constructor(private dashboardService: DashboardService, @Inject('COUNTRY_CONFIG') private countryConfig: any,
    private modalService: NgbModal, private cStorage: ClientSideStorageService) {
    this.placeHolders = this.placeholders['Messaging_Page']
    this.reportPlaceHolders = this.placeholders['Reports_page']
    this.paymentPlaceHolder = this.placeholders['paymentUsermgmt']
    this.dashboardPlaceHolder = this.placeholders['dashboard_page']
    this.toolTips = this.placeholders['tooltip']
    const postValue = this.cStorage.get('postcountry') ?? history.state.countryConfig.country
    this.countryConfig = this.getConfigByCountry(postValue) ?? defaultConfig;
    this.receiptlogo = this.countryConfig.loginPostlogo;
    this.userData = JSON.parse(this.cStorage.get("marketplaceData"));

    const today = new Date().toISOString().split('T')[0]; // Formats to YYYY-MM-DD
    this.today = today
    this.fromDate = today;
    this.toDate = today;
  }

  ngOnInit() {

    this.getPaymentData()
    this.getwalletPaymentData()
    this.getwalletAllPaymentData()
  }

  getWalletData() {
    this.getwalletPaymentData()
    this.getwalletAllPaymentData()
  }

  getConfigByCountry(country: string): any {
    switch (country) {
      case 'Botswana':
        return botswanaConfig;
      case 'Zimbabwe':
        return zimConfig;
      case 'Cote De Ivory':
        return coteivoryConfig;
      default:
        return defaultConfig;
    }
  }

  page: any;
  fromDate!: string;
  toDate!: string;
  selectedDate!: string;
  getPaymentData() {




    const payload = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      selectedDate: this.selectedDate
    };
    const fromDate = this.formatDate(this.fromDate)
    const toDate = this.formatDate(this.toDate)
    this.page = this.activePage - 1

    // this.dashboardService.paymentHistoryData(fromDate, toDate, this.userData.marketplace_id).subscribe((res: any) => {
    //   this.paymentTotalData = res.body.data.content;
    //   console.log(this.paymentTotalData)
    //   this.dataSource = this.paymentTotalData;
    //   this.totalCount = res.body.data.totalElements;
    //   this.currentPage = this.activePage;
    // });

    this.dashboardService.paymentHistoryData(fromDate, toDate, this.userData.marketplace_id, this.page).subscribe((res: any) => {
      this.paymentTotalData = res.body?.data?.content ?? []
      debugger
      // Select only specific fields
      this.dataSource = this.paymentTotalData.map((item: any) => ({
        date: item.created_date,
        name: item.deal_name,
        amount: item.amount,
        status: item.status,
        email: item.deal_uuid,
        type: item.type,
        description: item.description,
        display_brand: item.display_brand,
        card: item.last4,
        receiptId: item.receiptId
        // Add other required fields here
      }));

      this.totalCount = res?.body?.data?.totalElements ?? [];
      this.currentPage = this.activePage;
    });

    this.dashboardService.paymentHistoryAllData(this.userData.marketplace_id, fromDate, toDate,).subscribe((res: any) => {
      this.paymentTotalDataReport = res.body?.data?.content ?? []
    });

  }


  getwalletPaymentData() {

    const payload = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      selectedDate: this.selectedDate,
      fetchAll: false
    };
    const fromDate = this.formatDate(this.fromDate)
    const toDate = this.formatDate(this.toDate)
    this.page = this.activePage - 1

    // this.dashboardService.paymentHistoryData(fromDate, toDate, this.userData.marketplace_id).subscribe((res: any) => {
    //   this.paymentTotalData = res.body.data.content;
    //   console.log(this.paymentTotalData)
    //   this.dataSource = this.paymentTotalData;
    //   this.totalCount = res.body.data.totalElements;
    //   this.currentPage = this.activePage;
    // });

    this.dashboardService.walletHistoryData(payload, fromDate, toDate, this.userData.marketplace_id, this.page).subscribe((res: any) => {
      this.transactions = res.body?.data?.content ?? []
      debugger
      // Select only specific fields
      this.dataSource = this.paymentTotalData.map((item: any) => ({
        date: item.created_date,
        name: item.deal_name,
        amount: item.amount,
        status: item.status,
        email: item.deal_uuid,
        type: item.type,
        description: item.description,
        display_brand: item.display_brand,
        card: item.last4,
        receiptId: item.receiptId
        // Add other required fields here
      }));

      this.totalCount = res?.body?.data?.totalElements ?? [];
      this.currentPage = this.activePage;
    });

    this.dashboardService.paymentHistoryAllData(this.userData.marketplace_id, fromDate, toDate,).subscribe((res: any) => {
      this.paymentTotalDataReport = res.body?.data?.content ?? []
    });

  }

  allpdftransactions: any;
  getwalletAllPaymentData() {

    const payload = {
      fromDate: this.fromDate,
      toDate: this.toDate,
      selectedDate: this.selectedDate,
      fetchAll: true
    };
    const fromDate = this.formatDate(this.fromDate)
    const toDate = this.formatDate(this.toDate)
    this.page = this.activePage - 1

    // this.dashboardService.paymentHistoryData(fromDate, toDate, this.userData.marketplace_id).subscribe((res: any) => {
    //   this.paymentTotalData = res.body.data.content;
    //   console.log(this.paymentTotalData)
    //   this.dataSource = this.paymentTotalData;
    //   this.totalCount = res.body.data.totalElements;
    //   this.currentPage = this.activePage;
    // });

    this.dashboardService.walletHistoryData(payload, fromDate, toDate, this.userData.marketplace_id, this.page).subscribe((res: any) => {
      this.allpdftransactions = res.body?.data?.content ?? []
      debugger
      // Select only specific fields
      this.dataSource = this.paymentTotalData.map((item: any) => ({
        date: item.created_date,
        name: item.deal_name,
        amount: item.amount,
        status: item.status,
        email: item.deal_uuid,
        type: item.type,
        description: item.description,
        display_brand: item.display_brand,
        card: item.last4,
        receiptId: item.receiptId
        // Add other required fields here
      }));

      this.totalCount = res?.body?.data?.totalElements ?? [];
      this.currentPage = this.activePage;
    });

    this.dashboardService.paymentHistoryAllData(this.userData.marketplace_id, fromDate, toDate,).subscribe((res: any) => {
      this.paymentTotalDataReport = res.body?.data?.content ?? []
    });

  }

  recordTotalCount: any;
  tableData: any;
  filterValue: any;

  // loadTableData(param:any) {
  //   let data = {
  //     keywords: [],
  //     pagination: this.activePage,
  //     filterStatus: param
  //   }
  //   const fromDate ='07/19/2024'
  //   const toDate ='10/19/2024'
  //   this.dashboardService.paymentHistoryData(fromDate, toDate, this.userData.marketplace_id)
  //     .pipe(
  //       map((res: any) => {
  //         this.recordTotalCount = res?.body?.data?.TOTAL_DEALS;
  //         return res?.body?.data?.FAVORITED_DEALS.map((item: any) => ({
  //           dealId: item.deal.product_id,
  //           dealTitle: item.deal.product_name,
  //           validTo: item.deal.available_to,
  //           status: item.deal.status,
  //           currentHighProspects: item.details.totalUniqueProspects,
  //           messagesSent: item.details.totalCustomerOfferMade,
  //           currentPendingProspects: item.details.totalPendingProspects,
  //           totalSpent: item.details.totalSpend,
  //           originalData: item  // Store the entire original item
  //         }));
  //       })
  //     )
  //     .subscribe((transformedData: TableRow[]) => {
  //       this.tableData = transformedData;
  //       this.dataSource = this.tableData;
  //       this.totalCount = this.recordTotalCount;
  //       this.currentPage = this.activePage;
  //       // You can now use this.tableData as the data source for your table
  //     });
  // }
  openReceipt(deal: any) {
    debugger
    this.selectedDeal = deal;
    this.modalService.open(this.receiptModal, { size: 'lg' });
  }
  selectedDeal: any = null;



  generateReceipt(deal: any, merchant: any) {
    debugger
    const doc = new jsPDF();
    const img = new Image();
    img.src = this.receiptlogo; // your logo (jpg, png, webp etc.)

    img.onload = () => {
      // detect extension
      const ext = img.src.split('.').pop()?.toUpperCase() || 'PNG';

      doc.addImage(img, ext, 80, 5, 50, 30);
      doc.setFontSize(18);
      doc.text(this.dashboardPlaceHolder['LBL_PAYMENT_RECEIPT'], 105, 40, { align: 'center' });
      // --- Header Title ---


      // --- Merchant Info ---
      autoTable(doc, {
        startY: 45,
        head: [[this.dashboardPlaceHolder['LBL_TO'], this.dashboardPlaceHolder['LBL_FROM'], this.dashboardPlaceHolder['LBL_DATE'], this.dashboardPlaceHolder['LBL_RECEIPT_ID']]],
        body: [[
          `${this.userData.marketplace_name}\n${this.userData.addressLine1}\n${this.userData.business_contact_number}\n${this.userData.uuid}`,
          `MapMyId Inc. (AKA Ship2myid)\nAddress: Alpharetta, Georgia - 30005 \nGST Number:\nPAN Number:`, 
          new Date(deal.date || deal.createdAt).toLocaleDateString(),
          deal.receiptId || deal.referenceId || '-'
        ]],
        theme: 'grid',
        headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
        bodyStyles: { fillColor: [237, 250, 241] }
      });

      // --- Deal Table ---
      autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY + 10,
        head: [['Deal Name', 'Deal Id']],
        body: [[
          `${deal.name || deal?.dealDetails?.product_name || 'NA'}` || 'N/A',

          `${deal.email || deal?.referenceId || 'NA'}` || 'N/A',
        ]],
        theme: 'grid',
        headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
        bodyStyles: { fillColor: [237, 250, 241] }
      });

      // --- Payment Table ---
      autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY + 10,
        head: [['Amount paid for', this.dashboardPlaceHolder['LBL_DATE_FOR_PAYMENT'], this.dashboardPlaceHolder['PAY_STATUS'], this.dashboardPlaceHolder['LBL_PAYMENT_METHOD'], 'Amount']],
        body: [[
          `${this.placeHolders[deal.description] || deal?.dealDetails?.product_name} – ${deal.type}`,
          new Date(deal.date || deal.createdAt).toLocaleDateString(),
          `${deal.status || deal.type}`,
          `${deal.display_brand || ''} ${deal.last4 || this.getPaymentMethodText(deal?.type) || ''}`.trim() || 'N/A',
          // `$${deal.amount.toFixed(2)}`,
          `${(deal.amount.toFixed(2) < 0 ? deal.amount.toFixed(2) * -1 :
            deal.amount.toFixed(2))}`
        ]],
        theme: 'grid',
        headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
        bodyStyles: { fillColor: [237, 250, 241] }
      });

      // --- Summary ---
      const subtotal = deal.amount.toFixed(2) < 0 ? deal.amount.toFixed(2) * -1 :
        deal.amount.toFixed(2);
      const vat = 0;
      const total = Number(subtotal) + vat;

      autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY + 10,
        body: [
          ['', 'SUBTOTAL', `$${Number(subtotal).toFixed(2)}`],
          ['', 'VAT/GST', `$${vat.toFixed(2)}`],
          ['', 'TOTAL', `$${total.toFixed(2)}`]
        ],
        theme: 'grid',
        styles: { halign: 'right' },
        bodyStyles: { fillColor: [237, 250, 241] },
        columnStyles: {
          1: { fontStyle: 'bold', halign: 'right' },
          2: { fontStyle: 'bold', halign: 'right' }
        }
      });

      // ✅ Footer Section
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text(
        this.dashboardPlaceHolder['LBL_RECEIPT_FOOTER'],
        105,
        pageHeight - 20,
        { align: 'center', maxWidth: 180 }
      );
      doc.text(
        this.dashboardPlaceHolder['LBL_COMPUTER_GENERATED'],
        105,
        pageHeight - 12,
        { align: 'center' }
      );

      // --- Save ---
      doc.save(`receipt-${deal.receiptId}.pdf`);
    }
  }


  downloadPDF() {

    let merchant = {
      name: 'Merchant Pvt Ltd',
      address: '123 Main Street, City',
      phone: '+91-9876543210',
      email: 'merchant@email.com'
    };
    const deal = this.selectedDeal

    this.generateReceipt(deal, merchant)
    // deal = {
    //   date: '2025-08-10T00:00:06.358Z',
    //   name: 'Test deal for check box',
    //   amount: 5.4,
    //   status: 'succeeded',
    //   email: 'D-118MEI2K4XT3R',
    //   type: 'campaign',
    //   description: 'PAYMENT_AGAINST_DEAL',
    //   display_brand: 'Visa',
    //   card: '4242',
    //   receiptId: 'RCPT-12345'
    // };

    // if (!element) return;

    // html2canvas(element).then((canvas) => {
    //   const imgData = canvas.toDataURL('image/png');
    //   const pdf = new jsPDF();
    //   const imgWidth = 190;
    //   const pageHeight = 295;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   let position = 10;

    //   pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //   pdf.save(`receipt_${this.selectedTxn?.receiptId}.pdf`);
    // });
  }

  private formatDate(date: string): string {
    const d = new Date(date);
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }

  onPageChange(page: number): void {
    this.activePage = page;
    this.getPaymentData();
    this.getwalletPaymentData()
  }

  onRowClicked(row: TableRow) {

  }


  applyFilter(event: Event) {
  }

  getStatusClass(status: string): any {
    switch (status) {
      case 'succeeded': return 'active-chip';
      case 'TOPUP': return 'active-chip';
      case 'RESERVE': return 'active-chip';
      case 'CONSUME': return 'active-chip';
      case 'RESERVE_UPDATE': return 'pending-chip';
      case 'RELEASE': return 'pending-chip';
      case 'requires_capture': return 'pending-chip';
      case 'refunded': return 'paused-chip'
      case 'E': return 'expired-chip';
      case 'I': return 'inactive-chip';
      case 'D': return 'draft-chip';
      case 'U': return 'upcoming-chip';
      case 'S': return 'paused-chip';
      case 'failed': return 'rejected-chip';
      case 'N': return 'new-chip';
      case 'C': return 'completed-chip';
      default: return '';
    }
  }

  getStatusText(status: string): any {
    switch (status) {
      case 'succeeded': return this.toolTips['TIP_14'];
      case 'requires_capture': return 'Authorized';
      case 'refunded': return this.toolTips['TIP_13'];
      case 'E': return this.reportPlaceHolders['LBL_EXPIRED'];
      case 'I': return this.reportPlaceHolders['LBL_INACTIVE'];
      case 'D': return this.reportPlaceHolders['LBL_DRAFT'];
      case 'U': return this.reportPlaceHolders['LBL_UPCOMING'];
      case 'S': return this.reportPlaceHolders['LBL_PAUSED'];
      case 'failed': return this.toolTips['TIP_15'];
      case 'N': return this.reportPlaceHolders['LBL_NEW'];
      case 'C': return this.reportPlaceHolders['LBL_COMPLETED'];
      case 'TOPUP': return 'Funded';
      case 'RESERVE': return 'Paid';
      case 'CONSUME': return 'Paid';
      case 'RESERVE_UPDATE': return 'Refund';
      case 'RELEASE': return 'Refund';
      default: return 'Unsuccessful';
    }
  }

  getCardBrandImage(brand: string) {
    const brandLogos: { [key: string]: string } = {
      visa: 'assets/images/visa.png',
      mastercard: 'assets/images/master-card.png',
      american_express: 'assets/images/amexcard.png',
      discover: 'assets/images/discover.jpg',
      cartes_bancaires: 'assets/images/carnet.jpg',
      unionpay: 'assets/images/UnionPay.png',
      jcb: 'assets/images/jcb.jpg'
    };
    return brandLogos[brand] || 'assets/images/credit-card.png';
  }

  generatepaymentPDF() {
    let merchant = {
      name: this.userData.marketplace_name,
      contact: this.userData.business_contact_number,
      uuid: this.userData.uuid
    }
    this.generateDealsPDF(merchant, this.allpdftransactions)
  }

  generateDealsPDF(merchant: any, deals: any[]) {
    //     const doc = new jsPDF();

    //     // Merchant details
    //     doc.setFontSize(14);
    //     doc.text(`Merchant: ${merchant.name}`, 14, 20);
    //     // doc.text(`Contact: ${merchant.contact}`, 14, 28);
    //     doc.text(`UUID: ${merchant.uuid}`, 14, 28);

    //     // Horizontal line
    //     doc.setLineWidth(0.5);
    //     doc.line(10, 42, 200, 42);

    //     // Table data
    //     const tableData = deals.map(item => [
    //       new Date(item.created_date || item.createdAt).toLocaleString('en-GB'),
    //       item.deal_name ||  "NA",
    //       item.amount,
    //       item.status || item.type,
    //       // item.deal_uuid || item.referenceId || "NA",
    //       item.type,
    //       // item.description,
    //       item.display_brand || item.brandId || "-",
    //       item.last4 || "-",
    //       item.receiptId || item.referenceId || "-"
    //     ]);
    // // "Deal ID"
    //     autoTable(doc, {
    //       startY: 48,
    //       head: [["Date", "Name", "Amount", "Status" , "Type", "Brand", "Card", "Receipt ID"]],
    //       body: tableData,
    //       styles: { fontSize: 9, cellPadding: 2 },
    //       headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0] } // green header
    //     });

    //     // Save PDF
    //     doc.save("Deals_Payment_report.pdf");





    const doc = new jsPDF();
    const img = new Image();
    img.src = this.receiptlogo; // your logo (jpg, png, webp etc.)

    img.onload = () => {
      // detect extension
      const ext = img.src.split('.').pop()?.toUpperCase() || 'PNG';

      doc.addImage(img, ext, 80, 5, 50, 30);
      doc.setFontSize(18);
      doc.text('Transaction Summary', 105, 40, { align: 'center' });
      // --- Header Title ---


      // --- Merchant Info ---
      autoTable(doc, {
        startY: 45,
        head: [[this.dashboardPlaceHolder['LBL_TO'], this.dashboardPlaceHolder['LBL_FROM'], this.dashboardPlaceHolder['LBL_DATE']]],
        body: [[
          `${this.userData.marketplace_name}\n${this.userData.addressLine1}\n${this.userData.business_contact_number}\n${this.userData.uuid}`,
          `MapMyId Inc. (AKA Ship2myid)\nAddress: Alpharetta, Georgia - 30005 \nGST Number:\nPAN Number:`,
          new Date().toLocaleDateString(),
          // merchant.receiptId || 'NA' || '-'
        ]],
        theme: 'grid',
        headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
        bodyStyles: { fillColor: [237, 250, 241] }
      });

      const tableData = deals.map(item => [
        new Date(item.created_date || item.createdAt).toLocaleString('en-GB'),
        // item.deal_name || "NA",
        (item.amount.toFixed(2) < 0 ? item.amount.toFixed(2) * -1 :
          item.amount.toFixed(2)),
        item.status || this.getTypeText(item.type),
        // item.deal_uuid || item.referenceId || "NA",
        this.getPaymentMethodText(item.type),
        // item.description,
        item.display_brand || item.brandId || "-",
        // item.last4 || "-",
        item.receiptId || item.referenceId || "-"
      ]);
      // "Deal ID", "Name", "Card"
      autoTable(doc, {
        startY: (doc as any).lastAutoTable.finalY + 10,
        head: [["Date", "Amount", "Status", "Payment Method", "Brand", "Receipt ID"]],
        body: tableData,
        styles: { fontSize: 9, cellPadding: 2 },
        headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0] } // green header
      });

      // // --- Deal Table ---
      // autoTable(doc, {
      //   startY: (doc as any).lastAutoTable.finalY + 10,
      //   head: [['Deal Name', 'Deal Id']],
      //   body: [[
      //     `${deal.name || deal?.dealDetails?.product_name || 'NA'}` || 'N/A',

      //     `${deal.email || deal?.referenceId || 'NA'}` || 'N/A',
      //   ]],
      //   theme: 'grid',
      //   headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
      //   bodyStyles: { fillColor: [237, 250, 241] }
      // });

      // // --- Payment Table ---
      // autoTable(doc, {
      //   startY: (doc as any).lastAutoTable.finalY + 10,
      //   head: [['Amount paid for', this.dashboardPlaceHolder['LBL_DATE_FOR_PAYMENT'], this.dashboardPlaceHolder['PAY_STATUS'], this.dashboardPlaceHolder['LBL_PAYMENT_METHOD'], 'Amount']],
      //   body: [[
      //     `${this.placeHolders[deal.description] || deal?.dealDetails?.product_name} – ${deal.type}`,
      //     new Date(deal.date || deal.createdAt).toLocaleDateString(),
      //     `${deal.status || deal.type}`,
      //     `${deal.display_brand || ''} ${deal.last4 || ''}`.trim() || 'N/A',
      //     `$${deal.amount.toFixed(2)}`
      //   ]],
      //   theme: 'grid',
      //   headStyles: { fillColor: [199, 239, 206], textColor: [0, 0, 0], halign: 'center' },
      //   bodyStyles: { fillColor: [237, 250, 241] }
      // });

      // // --- Summary ---
      // const subtotal = deal.amount;
      // const vat = 0;
      // const total = subtotal + vat;

      // autoTable(doc, {
      //   startY: (doc as any).lastAutoTable.finalY + 10,
      //   body: [
      //     ['', 'SUBTOTAL', `$${subtotal.toFixed(2)}`],
      //     ['', 'VAT/GST', `$${vat.toFixed(2)}`],
      //     ['', 'TOTAL', `$${total.toFixed(2)}`]
      //   ],
      //   theme: 'grid',
      //   styles: { halign: 'right' },
      //   bodyStyles: { fillColor: [237, 250, 241] },
      //   columnStyles: {
      //     1: { fontStyle: 'bold', halign: 'right' },
      //     2: { fontStyle: 'bold', halign: 'right' }
      //   }
      // });

      // ✅ Footer Section
      const pageHeight = doc.internal.pageSize.height;
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text(
        this.dashboardPlaceHolder['LBL_RECEIPT_FOOTER'],
        105,
        pageHeight - 20,
        { align: 'center', maxWidth: 180 }
      );
      doc.text(
        this.dashboardPlaceHolder['LBL_COMPUTER_GENERATED'],
        105,
        pageHeight - 12,
        { align: 'center' }
      );

      // --- Save ---
      doc.save(`Transcations-${merchant?.name}.pdf`);
    }
  }

  viewTransaction(txn: any) {
    console.log("View transaction:", txn);
    // maybe show details modal
  }

  downloadReceipt(txn: any) {
    console.log("Download receipt for:", txn.id);
    // hit API endpoint or generate PDF
  }

  getTypeText(type: string): string {
    if (type === 'TOPUP') return 'Funded';
    if (type === 'CONSUME') return 'Paid';
    if (type === 'RESERVE') return 'Allocated';
    if (type === 'RESERVE_UPDATE') return 'Refunded'
    if (type === 'RELEASE') return 'Refunded'


    return '-';
  }

  getPaymentMethodText(type: string): string {
    if (type === 'TOPUP') return 'Manual Payment';
    if (type === 'CONSUME') return 'Prepaid Balance';
    if (type === 'RESERVE') return 'Allocated';
    if (type === 'RESERVE_UPDATE') return 'Reversed'
    if (type === 'RELEASE') return 'Reversed'
    return '-';
  }

}
